import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
  getplacewiseHotel,
  editplacewiseHotel,
} from "../store/slices/placewisehotel";
import { getPlaceList } from "../store/slices/places";

const EditPlaceHotel = () => {
  const { id } = useParams();
  const [place, setPlace] = useState();
  const [placeList, setplaceList] = useState([]);
  const [hotelName, sethotelName] = useState();
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };

    if (name === "place") {
      setPlace(value);
      validationErrors.place =
        value.trim() === "" ? "Please select a place" : "";
    }

    if (name === "hotelName") {
      sethotelName(value);
      validationErrors.hotelName =
        value.trim() === "" ? "Please enter hotel name" : "";
    }

    setErrors(validationErrors);
  };

  const validateForm = () => {
    let newErrors = {};

    // Places Validation
    if (!place || place.trim() === "") {
      newErrors.place = "Please select a place";
    }

    if (!hotelName || hotelName.trim() === "") {
      newErrors.hotelName = "Please enter hotel name";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  React.useEffect(() => {
    dispatch(getPlaceList())
      .unwrap()
      .then((data) => {
        setplaceList(data?.placesData || []);
      })
      .catch((err) => {
        console.error("Error fetching places:", err.message);
      });
  }, [dispatch]);

  useEffect(() => {
    const fetchPlaceDetails = async () => {
      try {
        let item = { id };
        const data = await dispatch(getplacewiseHotel(item)).unwrap();
        const place = data?.hotelData[0];
        sethotelName(place.hotelName || "");
        setPlace(place.place || "");
      } catch (error) {
        console.error("Failed to fetch hotel details:", error.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPlaceDetails();
  }, [dispatch, id]);

  const addPackage = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      console.log("Validation failed, please fix the errors.", errors);
      return;
    }

    setIsDisabled(true);
    setTimeout(() => setIsDisabled(false), 3000);

    const item = {
      hotelName,
      place,
      id,
    };

    try {
      await dispatch(editplacewiseHotel(item)).unwrap();
      alert("Hotel name edited successfully!");
      navigate("/admin/placewise-hotel");
    } catch (error) {
      alert(error);
      setIsDisabled(false);
    }
  };

  function cancel(e) {
    navigate(-1);
  }

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Edit Price</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/tour-package"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Airport Pickup Drop Price
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Edit Price</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form autoComplete="off" onSubmit={addPackage}>
            <div className="row mb-40">
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Place<span className="text-danger">*</span>
                </label>
                <select
                  name="place"
                  value={place}
                  onChange={handleChange}
                  className={`form-control ${errors.place ? "is-invalid" : ""}`}
                >
                  <option value="">Select</option>
                  {placeList?.map((placedata) => (
                    <option key={placedata._id} value={placedata._id}>
                      {placedata.name}
                    </option>
                  ))}
                </select>
                {errors.place && (
                  <div className="text-danger mt-2">{errors.place}</div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Hotel Name<span className="text-danger">*</span>
                </label>
                <input
                  name="hotelName"
                  value={hotelName}
                  onChange={handleChange}
                  placeholder="Hotel Name"
                  className={`form-control ${
                    errors.hotelName ? "is-invalid" : ""
                  }`}
                />

                {errors.hotelName && (
                  <div className="text-danger mt-2">{errors.hotelName}</div>
                )}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                type="button"
                onClick={cancel}
                className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isDisabled}
                className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditPlaceHotel;
